import Vue from '@triotech/vue-core/src/vendor/vue';
import TestMixin from '@/mixins/test';

const Test = new Vue({
  mixins: [
    TestMixin,
  ],
});

Vue.set(Vue.prototype, '$test', Test);

export default Test;
